import React, { useEffect } from 'react';
import { usePolygonContext } from 'src/contexts/polygon.context';
import { actionTypes } from 'src/ducks/polygon.duck';
import { getPolygonStatus } from 'src/selectors/polygon.selector';
import PolygonView from './polygons-list.view';

const Polygons: React.FC = () => {
  const { state, actions } = usePolygonContext();

  useEffect(() => {
    actions.listGET();
  }, [actions]);

  return (
    <PolygonView
      loading={
        getPolygonStatus(state, actionTypes.POLYGON_FETCH).fetching
      }
      data={state.list}
    />
  );
};

export default Polygons;
